export const onInitService = ({ getConfig, setContext }) => {
  const headerKey =
    process.env.REACT_APP_ACCESS_TOKEN_HEADER_KEY || "Authorization";
  const headerValue =
    process.env.REACT_APP_ACCESS_TOKEN_HEADER_VALUE || "Bearer {TOKEN}";
  const headerPropName = process.env.REACT_APP_HEADER_PROP || "headers";
  const urlPropName = process.env.REACT_APP_CUSTOM_URL_PROPERTY || "url";

  setContext(
    "one.rest.header.accessToken.key",
    getConfig("one.rest.header.accessToken.key", headerKey)
  );

  setContext(
    "one.rest.header.accessToken.value",
    getConfig("one.rest.header.accessToken.value", headerValue)
  );

  setContext(
    "one.rest.header.property.name",
    getConfig("one.rest.header.property.name", headerPropName)
  );

  setContext(
    "one.rest.url.property.name",
    getConfig("one.rest.url.property.name", urlPropName)
  );

  setContext(
    "one.rest.graphql.baseUrl",
    getConfig("one.rest.graphql.baseUrl", "hasuraApi")
  );
};
